import { useEffect } from "react";

const GA_ID = import.meta.env.VITE_GA_MEASUREMENT_ID;
let _pageViewTime = Date.now();

export function initGA() {
  if (!GA_ID) return;
  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  script.async = true;
  document.head.appendChild(script);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false });
}

export function trackPageView(path) {
  if (!window.gtag || !GA_ID) return;
  _pageViewTime = Date.now();
  window.gtag("event", "page_view", {
    page_path: path,
    page_location: window.location.href,
  });
}

export function trackEvent(eventName, params = {}) {
  if (!window.gtag || !GA_ID) return;
  window.gtag("event", eventName, params);
}

// Телефонний клік — автоматично додає час від завантаження сторінки
export function trackPhoneClick(location) {
  const seconds_on_page = Math.round((Date.now() - _pageViewTime) / 1000);
  trackEvent("phone_click", { location, seconds_on_page });
}

// Хук: глибина скролу — фіксує 25 / 50 / 75 / 100 %
export function useScrollDepth(pathname) {
  useEffect(() => {
    const fired = new Set();

    function onScroll() {
      const scrolled = window.scrollY + window.innerHeight;
      const total = document.documentElement.scrollHeight;
      const pct = Math.round((scrolled / total) * 100);

      for (const threshold of [25, 50, 75, 100]) {
        if (pct >= threshold && !fired.has(threshold)) {
          fired.add(threshold);
          trackEvent("scroll_depth", { percent: threshold, page: pathname });
        }
      }
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [pathname]);
}
